<!-- 节律 -->
<template>
  <div class="two_rhythm">
    <div class="blue_border">
      {{ $t('ifttt.rhythm') }}
    </div>
    <div class="step rhythm_step rhythm_step2">
      <el-steps
        :space="1000"
        :active="active_step"
        align-center
        finish-status="success"
      >
        <el-step
          :title="$t('ifttt.rhythm00')"
          @click.native="stepchange(1)"
        />
        <el-step
          :title="$t('ifttt.rhythm01')"
          @click.native="stepchange(2);"
        />
        <el-step
          :title="$t('ifttt.rhythm02')"
          @click.native="stepchange(3)"
        />
      </el-steps>
    </div>
    <div v-show="active_step == 1">
      <div class="dialogGroup_cont">
        <div
          class="dialogGroup_left no_group"
          style="width: 100%;"
        >
          <div class="tree_content">
            <div class="tree_title">
              {{ $t('ifttt.selectGateway') }}
              <!-- <img class="refresh" :class="{ activeRefresh: isrefresh }" src="../../assets/img/refrsh.png" /> -->
              <div class="ok_group">
                <button @click="selectGateway">
                  {{ $t('ifttt.nextStep') }}
                </button>
              </div>
            </div>
            <div class="custom-tree-container">
              <div class="ly-tree-container">
                <vuescroll>
                  <div class="wifi_tree">
                    <!-- <el-radio-group v-model="radio1" @change="changegateway" v-for="(item, index) in wifiData" :key="'a' + index">
											<el-radio-button style="background:red;" :label="item" :disabled="rhythmModel != null ? true : false">{{ item.DeviceName }}</el-radio-button>
										</el-radio-group> -->
                    <el-radio-group
                      v-for="(msg, index) in wifiData"
                      :key="'a' + index"
                      v-model="radio1"
                      class="wifi_tree_group"
                      style="height: max-content!important;"
                      @change="changegateway"
                    >
                      <el-radio
                        :label="msg"
                        :disabled="rhythmModel != null ? true : false"
                      >
                        <div
                          class="wifi_tree_body"
                          style="height: max-content; padding: 10px 0;"
                        >
                          <div class="wifi_tree_child">
                            <img
                              class="card_img"
                              :src="getClassSkuImage(msg,'on','../../assets/img/d_f1.png')"
                            >
                            <!-- <template v-if="msg.IconUrl">
                                <img class="card_img" :src="'/static/device/icon/' + msg.IconUrl" />
                              </template>
                              <template v-else>
                                <img class="card_img" src="../../assets/img/d_f2.png" />
                              </template> -->
                            <br>
                            {{ msg.DeviceName }}
                          </div>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </vuescroll>
              </div>
            </div>
            <!-- <div class="right_card_box" v-loading="loading" ref="video_area">
              <vuescroll>
                <el-row :gutter="20">
                  <div ref="video_area_context" style="overflow:auto">
                    <v-gatewaycard :registerList="[]" :isScrollRegist="false" :pageindex="1" :cardlist="wifiData" v-on:removeTree="removeTreeGateway" :is_check="true" :isradio="true"></v-gatewaycard>
                  </div>
                </el-row>
              </vuescroll>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div v-show="active_step == 2">
      <div class="dialogGroup_cont">
        <v-choose
          ref="deviceSelect"
          :is-ifttt="true"
          :is_group="false"
          :areaid="areaid"
          :area-tree-type="1"
          :execute-type="2"
          :is-compare="true"
          :displaynoarea="true"
          :checkeddata="rhythmModel && rhythmModel['DeviceList']"
          :post-fun-param="getPostFunParam()"
          :confirm-name="$t('ifttt.nextStep')"
          :is-show-check="true"
          :is-group-save-bar="false"
          :is-group-control-bar="true"
          :group-control-title-name="$t('ifttt.rhythm')"
          :group-control-name="$t('ifttt.groupControl')"
          :is-confirmc-calibrate="false"
          :is-rhythm="true"
          :is-occupied="true"
          :is-occupied-limit-group="true"
          :cur-rule-id="rhythmModel != null?rhythmModel['RhythmNo']:null"
          :is-cur-rule-group="(rhythmModel != null && rhythmModel['RhythmType']==0)?true:false"
          :post-fun-param-tree="radio1!=null?{gatewayVDeviceId:radio1.VDeviceId}:null"
          @confirm="confirm"
          @groupControlEvent="groupControlEvent"
        />
        <!-- <div class="dialogGroup_left no_group">
					<div class="tree_content">
						<div class="tree_title">
							{{ $t('tree.title') }}
							<img class="refresh" :class="{ activeRefresh: isrefresh }" src="../../assets/img/refrsh.png" />
						</div>

						<div class="custom-tree-container">
							<div class="ly-tree-container">
								<vuescroll>
									<div class="wifi_tree">
										<el-radio-group v-model="radio1" @change="changegateway" v-for="(item, index) in wifiData" :key="'a' + index">
											<el-radio-button :label="item" :disabled="rhythmModel != null ? true : false">{{ item.DeviceName }}</el-radio-button>
										</el-radio-group>
									</div>
								</vuescroll>
							</div>
						</div>
					</div>
				</div>

				<div class="dialogGroup_right">
					<div class="Group_right_header">
						<div class="blue_header">
							<span>
								{{ $t('deviceChoose.choose') }}
								<template v-if="cardNum">
									（
									<em>{{ card_list.length }}</em>
									）
								</template>
							</span>
						</div>

						<div class="ok_group">
              <div class="select_but" style="display: inline-flex; margin-right: 20px; margin-top: 6px;">
                <el-checkbox @change="checkAll" v-model="select">{{select?$t('scene.all'):$t('scene.allno')}}
                </el-checkbox>
              </div>
							<template v-if="checkDevice.length > 0">
								<el-badge :value="checkDevice.length" class="item">
									<button @click="createGrop">{{ $t('deviceChoose.sure') }}</button>
								</el-badge>
							</template>
							<template v-else>
								<button @click="createGrop">{{ $t('deviceChoose.sure') }}</button>
							</template>
						</div>
					</div>
					<div class="right_card_box" v-loading="loading">
						<vuescroll>
							<div v-if="refresh"><v-card :registerList="registerList" :isScrollRegist="isScrollRegist" :cardlist="card_list" :noclick="true" :is_check="true" :isradio="false" v-on:removeTree="removeTreeDevice"></v-card></div>
						</vuescroll>
					</div>
				</div> -->
      </div>
    </div>
    <div
      v-show="active_step == 3"
      class="ehystep2_cont"
    >
      <div class="ehy_cont">
        <div
          class="custom_base"
          style="text-align: center;padding-top: 10px;"
        >
          <span>{{ $t('ifttt.rhythmName') }}：</span>
          <input
            v-model="name"
            :placeholder="$t('ifttt.rhythmNameTips')"
            maxlength="32"
          >
        </div>
        <span class="title_ehy">{{ $t('ifttt.rhythm') }}</span>
        <span class="info_ehy">{{ $t('ifttt.timeSet') }}</span>
        <div
          class="tab_header clearfix"
          style="position: relative;"
        >
          <!--节律曲线-->
          <div
            class="header_tabset set1"
            :class="{ header_current: cur == 0 }"
            @click="clickrhythmline(0)"
          >
            {{ $t('ifttt.rhythmLine') }}
          </div>
          <div
            class="header_tabset set2"
            :class="{ header_current: cur == 1 }"
            @click="clickrhythmline(1)"
          >
            {{ $t('ifttt.set') }}
          </div>
        </div>
        <div
          class="tab-content clearfix"
          style="margin-top: 10px;"
        >
          <div
            v-show="cur == 0"
            class="secont_tab_cont"
          >
            <div class="secont_tab_header">
              <div
                class="second_tab"
                :class="{ second_current: curs == 0 }"
                @click="curs = 0"
              >
                {{ $t('ifttt.lightDevice') }}
              </div>
              <div
                class="second_tab"
                :style="$store.state.isNoLimit?'':'display:none'"
                :class="{ second_current: curs == 1 }"
                @click="curs = 1"
              >
                {{ $t('ifttt.window') }}
              </div>
            </div>
            <div class="second_tab_cont">
              <div
                v-show="curs == 0"
                class="second_tab_list"
              >
                <template v-if="rhythmModel==null">
                  <div class="rhythm_img_box">
                    <span class="rhythm_img_info">{{ $t('ifttt.zdylight') }}</span>
                  </div>
                </template>
                <template v-else>
                  <template v-if="hasdata(1)==false">
                    <div class="rhythm_img_box">
                      <span class="rhythm_img_info">{{ $t('ifttt.zdylight') }}</span>
                    </div>
                  </template>
                </template>
                <div
                  id="barChart"
                  class="bar_chart_set"
                />
              </div>
              <div
                v-show="curs == 1"
                class="second_tab_list"
              >
                <div class="swiper_tab">
                  <div class="swiper-content">
                    <div>
                      <template v-if="rhythmModel!=null">
                        <template v-if="windowcheck!=null">
                          <div class="rhythm_img_box">
                            <img
                              class="swiper_img"
                              :src="imgpic"
                            >
                          </div>
                          <div class="swiper_msg">
                            <div class="swiper_list">
                              <em class="swiper_dot red_dot" />
                              {{ $t('ifttt.openDegree') }}：
                              <span>{{ windowcheck.Opendegree }}%</span>
                            </div>
                            <div class="swiper_list">
                              <em class="swiper_dot blue_dot" />
                              {{ $t('ifttt.Degree') }} ：
                              <span>{{ windowcheck.Degree }}°</span>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="rhythm_img_box">
                            <img
                              class="swiper_img"
                              :src="require('@static/ifttt/window/0-0.png')"
                            >
                            <span class="rhythm_img_info">{{ $t('ifttt.zdy') }}</span>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <div class="rhythm_img_box">
                          <img
                            class="swiper_img"
                            :src="require('@static/ifttt/window/0-0.png')"
                          >
                          <span class="rhythm_img_info">{{ $t('ifttt.zdy') }}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="swiper_header">
                    <template v-if="lightTimeList!=null">
                      <template
                        v-for="(item,index) in lightTimeList"
                        v-if="item.DevType==2"
                      >
                        <div
                          :key="'w'+index"
                          class="swiper_title"
                          :class="{ tab_current: curswiper == index }"
                          @click="changeTime(item,index)"
                        >
                          {{ item.time[0] }} ~ {{ item.time[1] }}
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="cur == 1"
            class="secont_tab_cont"
          >
            <el-dropdown
              class="add_tab"
              @command="handleAdd"
            >
              <span class="el-dropdown-link">
                {{ modetypename }}<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item,index) in optionsAdd"
                  :key="index"
                  :command="item"
                >
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="secont_tab_header">
              <div
                class="second_tab"
                :class="{ second_current: curs == 0 }"
                @click="curs = 0"
              >
                {{ $t('ifttt.lightDevice') }}
              </div>
              <div
                class="second_tab"
                :style="$store.state.isNoLimit?'':'display:none'"
                :class="{ second_current: curs == 1 }"
                @click="curs = 1"
              >
                {{ $t('ifttt.window') }}
              </div>
            </div>
            <div class="second_tab_cont">
              <div
                v-show="curs == 0"
                class="second_tab_list"
              >
                <div class="user-defined">
                  <vuescroll>
                    <div
                      v-for="(item,index) in lightTimeList"
                      v-if="item.DevType==1"
                      :key="'a'+index"
                      class="use_defined_line clearfix"
                    >
                      <div style="display: inline-block;width: 100%;margin: 5px 0;">
                        <span style="margin-right: 20px;">{{ $t('ifttt.rhythmSelectJoinModel') +':' }}</span>
                        <el-checkbox
                          v-model="item['EnableLight']"
                          :disabled="(item['EnableCCT'] == false && item['EnableRGB'] == false && item['EnableLight'] == true)?true:false"
                          :label="$t('ifttt.lightName')"
                        />
                        <el-checkbox
                          :disabled="((item['EnableCCT'] != false || item['EnableRGB'] != false) && item['EnableLight'] == false)?true:false"
                          :label="$t('ifttt.colorName')+'/'+$t('ifttt.color')"
                          :checked="getEnableCCTEnableRGB(item)"
                          @change="changeEnableCCTEnableRGB($event,item)"
                        />
                      </div>
                      <div style="display: inline-block;width: 100%;">
                        <em class="blue_dot" />
                        <el-time-picker
                          v-model="item.time"
                          :editable="true"
                          class="dialog_time"
                          is-range
                          format="HH:mm"
                          value-format="HH:mm"
                          :range-separator="$t('ifttt.timeAdd')"
                          :clearable="false"
                          :style="item['error']?'border: dashed 1px red;':''"
                          @change="docheckTimeisEndToStar(item,'time','error')"
                        />
                        <!-- popper-class='only_hour' -->
                        <div
                          v-if="item['EnableLight']==true"
                          class="slider_width"
                        >
                          <span class="slide_text1">{{ $t('ifttt.lightName') }}</span>
                          <div class="slider_percent input_slider">
                            <span
                              class="lightUnit lingthUnit_slider"
                              style="right: 2px;top:9px"
                            >%</span>
                            <el-slider
                              v-model="item.Bright"
                              :min="minLight"
                              :max="100"
                              show-input
                            />
                          </div>
                        </div>
                        <template>
                          <div
                            v-if="getEnableCCTEnableRGB(item)"
                            class="slider_width"
                            :style="item['EnableCCT']?'':'opacity: 0.5;'"
                          >
                            <span class="slide_text1">{{ $t('ifttt.colorName') }}</span>
                            <div class="slider_percent input_slider slider_color">
                              <el-slider
                                v-model="item.CCT"
                                :min="$store.state.colorTemperatureRange.Min"
                                :max="$store.state.colorTemperatureRange.Max"
                                show-input
                                @change="ctrltypechange(1,item)"
                              />
                            </div>
                          </div>
                        </template>
                        <div class="slider_width">
                          <span class="slide_text1">{{ $t('ifttt.Illuminance') }}</span>
                          <el-input-number
                            v-model="item.Illuminance"
                            :min="0"
                            :max="3000"
                            class="slider_input"
                            style="margin-left: 2px;"
                          />
                        </div>

                        <template>
                          <div
                            v-if="getEnableCCTEnableRGB(item)"
                            class="slider_width"
                            :style="item['EnableRGB']?'':'opacity: 0.5;'"
                          >
                            <span class="slide_text1">{{ $t('ifttt.color') }}</span>
                            <el-color-picker
                              v-model="item.RGB"
                              style="margin-left: 2px;margin-top: 4px;"
                              @change="ctrltypechange(0,item)"
                            />
                          </div>
                        </template>
                        <i
                          class="icon--1 slider_del"
                          @click="delLightTime(index)"
                        />
                      </div>
                    </div>
                  </vuescroll>
                  <el-button
                    class="add_time de-add--time"
                    type="primary"
                    icon="el-icon-plus"
                    @click="addTimeLight"
                  >
                    {{ $t('ifttt.addTime') }}
                  </el-button>
                </div>
              </div>
              <div
                v-show="curs == 1"
                class="second_tab_list"
              >
                <div class="user-defined">
                  <vuescroll>
                    <div
                      v-for="(item,index) in lightTimeList"
                      v-if="item.DevType==2"
                      :key="'b'+index"
                      class="use_defined_line clearfix"
                    >
                      <em class="blue_dot" />
                      <el-time-picker
                        v-model="item.time"
                        :editable="true"
                        class="dialog_time"
                        is-range
                        format="HH:mm"
                        value-format="HH:mm"
                        :range-separator="$t('ifttt.timeAdd')"
                        :clearable="false"
                        :style="item['error']?'border: dashed 1px red;':''"
                        @change="docheckTimeisEndToStar(item,'time','error')"
                      />
                      <!-- popper-class='only_hour' -->
                      <div class="slider_width">
                        <span class="slide_text1">{{ $t('ifttt.openDegree') }}</span>
                        <div class="slider_percent">
                          <el-slider
                            v-model="item.Opendegree"
                            :min="0"
                            :max="100"
                          />
                          <span class="slider_start">0%</span>
                          <span class="slider_end">100%</span>
                        </div>
                        <span class="slide_text2">{{ item.Opendegree }}%</span>
                      </div>
                      <div
                        v-show="item.Opendegree === 0"
                        class="slider_width"
                      >
                        <span class="slide_text1">{{ $t('ifttt.Degree') }}</span>
                        <div class="slider_percent">
                          <el-slider
                            v-model="item.Degree"
                            :min="0"
                            :max="180"
                          />
                          <span class="slider_start">0°</span>
                          <span class="slider_end">180°</span>
                        </div>
                        <span class="slide_text2">{{ item.Degree }}°</span>
                      </div>
                      <i
                        class="icon--1 slider_del"
                        @click="delLightTime(index)"
                      />
                    </div>
                  </vuescroll>
                  <div class="user_info">
                    <em>*</em>
                    {{ $t('ifttt.info') }}
                  </div>
                  <el-button
                    class="add_time"
                    type="primary"
                    icon="el-icon-plus"
                    @click="addTimeWindow"
                  >
                    {{ $t('ifttt.addTime') }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="cur == 1"
        class="button_box clearfix"
      >
        <el-button
          class="fleft"
          @click="upstep2"
        >
          {{ $t('ifttt.upStep') }}
        </el-button>
        <el-button
          :loading="btnloading"
          class="fright save_blue"
          @click="save"
        >
          {{ $t('ifttt.save') }}
        </el-button>
        <!-- <el-checkbox class="card_check" v-model="isGroupPost" :disabled="isGroupPostDisabled" v-if="wifiData.length==1" style="margin: 10px 5px 10px 50px;">{{ $t('ifttt.groupControl') }}</el-checkbox> -->
      </div>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll'
import vGatewaycard from '@/components/common/cardtwoSmall.vue'
import vCard from '@/components/common/card.vue'
import vChoose from '@/components/common/deviceChoose.vue'
import echarts from 'echarts'
import { Create, Edit, FindRhythm } from '@/axios/IRhythm.js'
import { FindGatewayList } from '@/axios/IArea.js'
import { FindDeviceListByPage, FindDevice } from '@/axios/IDevice.js'
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js'
import { postWebIOSocket } from '@assets/socket'
import { catchRequireErr } from '@utils/utils'
export default {
  components: {
    vuescroll,
    vChoose,
    vCard,
    vGatewaycard
  },
  props: {
    gpNo: {
      type: Number,
      default: -1 // 区域id
    },
    constantid: {
      type: Number,
      default: -1 // 恒照度id
    }
  },
  data () {
    return {
      areaid: -1,
      name: this.$t('iftttset.rhythm'),
      loading: false, // 是否加载中
      btnloading: false, // 保存加载中
      refresh: false, // 让组件加载
      isrefresh: false, // 是否刷新
      optionsAdd: [{
			  value: 0,
			  label: this.$t('ifttt.hourxh')
      }, {
			  value: 1,
			  label: this.$t('ifttt.secondsxh')
      }], // 模式选择 24小时 24秒
      modetypename: this.$t('ifttt.hourxh'), // 中文描述
      modetype: 0, // 循环模式 0默认模式（24小时循环） 1演示模式（24秒循环）
      lightTimeList: [], // action对象
      lightTime: [], // 灯具配置集合
      windowtime: [], // 窗帘配置集合
      checkDevice: [], // 选中的设备集合
      rhythmModel: null, // 节律对象
      windowcheck: null, // 选中的时间段对象
      imgpic: '', // 窗帘默认图
      active_step: 1, // 选择的步骤
      card_set: false, // 未使用
      cardNum: true, // 设备总数
      okCheckNum: 0, // 选择数量
      is_device: false, // 未使用
      is_check: true, // 是否复选
      selectMore: true, // 未使用
      cur: 0, // 0 曲线 1 自定义
      curs: 0, // 0 灯具 1 窗帘
      percent: 30, // 未使用
      curswiper: -1, // 窗帘时间段索引
      time: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)], // 未使用
      tabMain: [
        { persent: '0', angle: '180' },
        { persent: '50', angle: '50' },
        { persent: '70', angle: '60' },
        { persent: '40', angle: '80' },
        { persent: '90', angle: '150' }
      ], // 未使用
      radio1: '', // 选择的网关
      wifiData: [], // 网关列表
      card_list: [], // 设备集合
      registerList: [], // 注册的设备
	  isScrollRegist: false, // 是否滚动
      isGroupPost: false,
      isGroupPostDisabled: false,
      select: false, // 全选按钮
      curRuleId: null, // 当前规则ID
      isCurRuleGroup: null, // 修改当前规则（是否组控）
      minLight:this.$store.state.staticConfig.AbilityConfig.DefaultValue.Schedule['0x03130000'].Value.minValue
    }
  },
  destroyed () {
    this.initsocket()
    // this.removehighid();
  },
  created () {
    this.areaid = this.gpNo
    this.initsocket()
  },
  mounted () {
    this.areaid = this.gpNo
    // if (this.areaid != -1) {
    this.dofindination()
    // this.drawLine();
    // }
  },
  methods: {
    changeEnableCCTEnableRGB (event, item) {
      if (event) {
        item.EnableCCT = true
        item.EnableRGB = false
      } else {
        if (item.EnableLight != true) { return }
        item.EnableCCT = false
        item.EnableRGB = false
      }
    },
    getEnableCCTEnableRGB (item) {
      return item.EnableCCT || item.EnableRGB
    },
    stepchange (_step) {
      // if(!(this.verifyGateway())){
      //   return;
      // }
      this.active_step = _step
      if (this.active_step == 2) {
        this.$forceUpdate()
        setTimeout(param => { this.$refs.deviceSelect.refresh() }, 100)
        if (this.isGroupPost == true) {
          setTimeout(this.groupControlEvent, 100, this.isGroupPost)
        }
      }
    },
    groupControlEvent (event) {
      this.isGroupPost = event
      this.$refs.deviceSelect.groupEventNone(event)
      if (event == true) { this.$refs.deviceSelect.checkAll(false) }
      this.$refs.deviceSelect.setGroupControlValue(this.isGroupPost)
      if (event) { warning(this, this.$t('ifttt.groupControlTip')) }
    },
    verifyGateway () {
      if (this.wifiData != null && this.wifiData.length > 0) {
        return true
      } else {
        warning(this, this.$t('ifttt.noFindGateWayTip'))
        return false
      }
    },
    selectGateway () {
      if (this.verifyGateway()) {
        this.active_step = 2

        let refObj = this.$refs
        refObj = refObj && refObj.deviceSelect
        if (refObj != null) {
          refObj.card_list2 = []
          setTimeout(param => { this.$refs.deviceSelect.refresh() }, 100)
        }
        refObj = null
      }
    },
    /* 移除socket
		*/
    initsocket () {
      postWebIOSocket('sync_info_removeall_event')
      this.$store.dispatch('changeIsregisterSocket', true)
    },
    hasdata (val) {
      let rtvalue = false
      this.lightTimeList.forEach(n => {
        if (n.DevType == val) {
          rtvalue = true
        }
      })
      return rtvalue
    },
    /* 点击画灯具节律曲线
		*/
    clickrhythmline (_cur) {
      this.cur = _cur

      if (_cur == 0) {
        if (this.rhythmModel != null) {
          this.dodrawline()
        }
      }
    },
    /* 改变窗帘 开合度角度 图片随之变化
		* item：选择的对象
		*/
    changewindow (item) {
      let picdegree = -1
      for (let i = 0; i < 6; i++) {
        const startdegree = i * 30
        const enddegree = (i + 1) * 30
        if (i == 5) {
          if (item.Degree == 0 || item.Degree == 180) {
            picdegree = 0
            break
          }
        } else if (item.Degree > startdegree && item.Degree <= enddegree) {
            picdegree = enddegree
            break
          }
      }
      for (let t = 0; t < 4; t++) {
        const startopendegree = t * 25
        const endopendegree = (t + 1) * 25
        if (item.Opendegree != 0 && picdegree > 0) {
          if (item.Opendegree > startopendegree && item.Opendegree <= endopendegree) {
            this.imgpic = catchRequireErr(() => require('@static/ifttt/window/' + picdegree + '-' + endopendegree + '.png'))
          }
        } else {
          this.imgpic = require('@static/ifttt/window/0-0.png')
        }
      }
    },
    /* 窗帘点击时间段
		* item：选择的对象
		* index 索引
		*/
    changeTime (item, index) {
      // 窗帘点击时间段
      this.curswiper = index
      this.windowcheck = item
      this.changewindow(item)
    },
    /* 画柱状图
		* _ss：色温
		* _data 照度值
		*/
    drawLine (_ss, _data, _time) {
      const ss = _ss
      // console.log(ss);
      // console.log(_data);
      const myChart = echarts.init(document.getElementById('barChart'))
      if (this.hasdata(1)) {
        myChart.setOption({
          title: {
            text: ''
          },
          grid: {
            left: '8%',
            right: '8%',
            bottom: '8%',
            top: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              name: this.$t('ifttt.rhythmtime') + '(H)',

              nameTextStyle: {
                color: '#292929'
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#1d1d1d'
                }
              },

              axisLine: {
                lineStyle: {
                  color: '#bec4d0',
                  width: 1
                }
              },
              // data: [ '0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
              data: _time
            }
          ],

          yAxis: [
            {
              type: 'value',
              name: this.$t('ifttt.Illuminance'),
              nameLocation: 'middle',
              nameGap: '65',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#262626'
                }
              },
              axisLabel: {
                margin: 12,
                textStyle: {
                  fontSize: 12
                }
              },
              splitLine: {
                lineStyle: {
                  color: '#eff2f7'
                }
              }
            }
          ],
          series: [
            {
              type: 'bar',
              barCategoryGap: '0',

              itemStyle: {
                normal: {
                  color: function (params) {
                    if (ss[params.dataIndex] >= 2700 && ss[params.dataIndex] < 3000) {
                      return '#e4dd45'
                    } else if (ss[params.dataIndex] >= 3000 && ss[params.dataIndex] < 3300) {
                      return '#e3dd5a'
                    } else if (ss[params.dataIndex] >= 3300 && ss[params.dataIndex] < 3600) {
                      return '#e1de70'
                    } else if (ss[params.dataIndex] >= 3600 && ss[params.dataIndex] < 3900) {
                      return '#dfde85'
                    } else if (ss[params.dataIndex] >= 3900 && ss[params.dataIndex] < 4200) {
                      return '#dedf9a'
                    } else if (ss[params.dataIndex] >= 4200 && ss[params.dataIndex] < 4500) {
                      return '#dadfb5'
                    } else if (ss[params.dataIndex] >= 4500 && ss[params.dataIndex] < 4800) {
                      return '#d8e0ce'
                    } else if (ss[params.dataIndex] >= 4800 && ss[params.dataIndex] < 5100) {
                      return '#d1dee0'
                    } else if (ss[params.dataIndex] >= 5100 && ss[params.dataIndex] < 5400) {
                      return '#bed2e3'
                    } else if (ss[params.dataIndex] >= 5400 && ss[params.dataIndex] < 5700) {
                      return '#aac7e5'
                    } else if (ss[params.dataIndex] >= 5700 && ss[params.dataIndex] < 6000) {
                      return '#96bbe8'
                    } else if (ss[params.dataIndex] >= 6000 && ss[params.dataIndex] < 6300) {
                      return '#84b1ec'
                    } else if (ss[params.dataIndex] >= 6300 && ss[params.dataIndex] <= 6500) {
                      return '#629df0'
                    }
                  }

                }
              },
              data: _data
            }
          ]
        })
      } else {
        myChart.clear()
      }
    },
    /* 下拉改变模式
		* item：下拉对象
		*/
    handleAdd (item) {
      this.modetypename = item.label
      this.modetype = item.value
    },
    /* 初始化数据 如果已经有节律配置 则对老数据赋值
		*/
    getAction () {
      if (this.rhythmModel != null) {
        if (this.rhythmModel.ActionList.length > 0) {
          this.rhythmModel.ActionList.forEach(n => {
            let _model = {}
            const _timearry = []
            _timearry.push((n.StartHour >= 10 ? n.StartHour : '0' + n.StartHour) + ':' + (n.StartMin >= 10 ? n.StartMin : '0' + n.StartMin))
            _timearry.push((n.EndHour >= 10 ? n.EndHour : '0' + n.EndHour) + ':' + (n.EndMin >= 10 ? n.EndMin : '0' + n.EndMin))
            _model.time = _timearry
            _model.Bright = this.rhythmlLightInforValue(n.Bright)
            _model.CCT = n.CCT
            _model.CtrlType = n.CtrlType
            _model.Opendegree = n.Opendegree
            _model.Degree = n.Degree
            _model.DevType = n.DevType
            _model.Illuminance = n.Illuminance
            _model.EnableLight = n.EnableLight
            _model.EnableCCT = n.EnableCCT
            _model.EnableRGB = n.EnableRGB
            if (_model.CtrlType == 0) {
              _model.RGB = '#' + n.RGB.toString(16)
            }

            this.docheckTimeisEndToStar(_model, 'time', 'error')
            this.lightTimeList.push(_model)
            _model = null
          })
          let isadd = false
          let icount = 0
          this.lightTimeList.forEach(n => {
            if (!isadd) {
              if (n.DevType == 2) {
                this.changeTime(n, icount)
                isadd = true
              }
            }
            icount++
          })
          this.dodrawline()
        }
      }
    },
    /* 去画柱状图
		*/
    dodrawline () {
      let ss = [] // 色温
      let data = [] // 照度
      const time = []// 自定义时间
      // for (let i = 0; i < 24; i++) {
      // 	ss.push(0);
      // 	data.push(0);
      // }
      // this.lightTimeList.forEach(n=>{
      // 	if(n.DevType==1){
      // 		var _st=parseInt(n.time[0]);
      //     var _ed=parseInt(n.time[1]);
      // 		for (let i = 0; i <= _ed-_st; i++) {
      // 			ss[i+_st]=n.CCT;
      // 			data[i+_st]=n.Illuminance;
      // 		}
      // 	}
      // });
      this.lightTimeList.forEach(n => {
        if (n.DevType == 1) {
          ss.push(n.CCT)
          data.push(n.Illuminance)
          time.push(n.time[0])

          ss.push(n.CCT)
          data.push(n.Illuminance)
          time.push(n.time[1])
        }
      })

      this.drawLine(ss, data, time)
      ss = null
      data = null
    },
    confirm (val) {
      this.removeTreeDevice([val])
      this.createGrop()
    },
    /* 点击选中设备
		* list 点击对象
		*/
    removeTreeDevice (list) {
      // 选中的设备
      this.card_list = list[0]
      this.getCheckedDataDevice()
    },
    /* 获得选中的设备
		*/
    getCheckedDataDevice () {
      let _arry = []
      this.card_list.forEach(item => {
        if (item.ischecked) {
          _arry.push(item)
        }
      })
      this.checkDevice = _arry
      _arry = null

      if (this.checkDevice.length == this.getCardTolal()) {
        this.select = true
      } else {
        this.select = false
      }
    },
    getCardTolal () {
      let num = 0
      this.card_list.forEach(item => {
        if (item.hidden != true) {
          num++
        }
      })
      return num
    },
    /* 删除灯具的时间段
		*/
    delLightTime (index) {
      this.lightTimeList.splice(index, 1)

      this.lightTime = []
      this.windowtime = []
      let _st, _ed, _t1, _t2
      this.lightTimeList.forEach(n => {
        if (n.error == true) { ispost = false }
        if (n.DevType == 1) {
          this.lightTime.push(n)
        } else if (n.DevType == 2) {
          this.windowtime.push(n)
        }
      })

      alertsuccess(this, this.$store.state.rightStatusCode)
    },
    /* 添加灯具的时间段
		*/
    addTimeLight () {
      let starTime = '00:00'

      if (this.lightTime.length > 0) { starTime = this.lightTime[this.lightTime.length - 1].time[1] }
      this.lightTimeList.push({ EnableLight: true, EnableCCT: false, EnableRGB: false, error: false, time: [starTime, '23:59'], Bright: 0, Illuminance: undefined, CCT: 2700, RGB: null, CtrlType: 1, Opendegree: 0, Degree: 0, DevType: 1 })
      starTime = null
      this.saverhythmModel()
    },
    /* 添加窗帘的时间段
		*/
    addTimeWindow () {
      let starTime = '00:00'
      if (this.windowtime.length > 0) { starTime = this.windowtime[this.windowtime.length - 1].time[1] }
      this.lightTimeList.push({ EnableLight: false, EnableCCT: false, EnableRGB: false, error: false, time: [starTime, '23:59'], Bright: 0, Illuminance: 0, CCT: 2700, RGB: null, CtrlType: 1, Opendegree: 0, Degree: 0, DevType: 2 })
      starTime = null
      this.saverhythmModel()
    },
    /* 改变颜色执行的方法
		* ctrltype 类型
		* item 执行对象
		*/
    ctrltypechange (ctrltype, item) {
      item.CtrlType = ctrltype
      if (ctrltype == 0) {
        // 调光方式为颜色 将色温设为初始值
        if (item.RGB == null) {
          item.CtrlType = 1
        } else {
          item.CCT = 2700
        }
        item.EnableCCT = false
        item.EnableRGB = true
      } else {
        // 调光方式为色温 将颜色设为初始值
        item.RGB = null
        item.EnableCCT = true
        item.EnableRGB = false
      }
    },
    /* 页面初始化查询节律
		*/
    dofindination () {
      // if (this.areaid != -1) {
      if (this.constantid != -1 && this.constantid != null) {
        let para = { gpNo: this.areaid, RhythmNo: this.constantid }
        FindRhythm(para, this.functionDoFind)
        para = null
      } else {
        let _param = this.$store.state.areasGpName[this.areaid]
        _param = _param && _param.GpName + '.'
        this.name = _param + this.$t('iftttset.rhythm')
        _param = null
        this.doFindGatewayList()
      }
      // }

      // if (this.areaid != -1) {
      //   if(this.constantid != -1 && this.constantid != null){
      //     var para = { gpNo: this.areaid, rhythmNo: this.constantid };
      //     Find(para, this.functionDoFind);
      //     para = null;
      //   }else{
      //     this.doFindGatewayList();
      //   }
      // }
    },
    /* 页面初始化查询节律 接口返回加数据处理 对数据赋值
		* rs 接口返回的数据包
		*/
    functionDoFind (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          this.rhythmModel = rs.Result
          if (this.rhythmModel.RhythmName != null) { this.name = this.rhythmModel.RhythmName }
          if (this.rhythmModel && this.rhythmModel.DeviceList) { this.checkDevice = this.rhythmModel.DeviceList }
          this.modetype = this.rhythmModel.Mode
          this.isGroupPost = this.rhythmModel.RhythmType == 0
          this.modetypename = this.optionsAdd[this.modetype].label
          try {
            this.areaid = this.rhythmModel.GpNo
          } catch (error) {

          }

          this.getAction()
          // 编辑赋值
          // this.getSegmentlist();

          this.docheckTimeisRight()
          // if(this.isGroupPost == true){this.groupControlEvent(true);}
          this.active_step = 3
        }
        this.doFindGatewayList()
      }
    },
    /* 查询网关
		*/
    doFindGatewayList () {
      // 获得网关
      let para = { gpNo: this.areaid }
      FindGatewayList(para, this.functionDoFindGatewayList)
      para = null
    },
    /* 查询网关 接口返回数据处理 如果是有节律 则选择节律已经选中的网关 如果没有则默认第一个网关
		* rs 接口返回的数据包
		*/
    functionDoFindGatewayList (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.wifiData = (rs.Result || []).filter(item => item.ClassSku !== '0x19070001');
        if (this.wifiData != null && this.wifiData.length > 0) {
          if (this.rhythmModel != null) {
            if (this.isGroupPost == true) {
              if (this.rhythmModel.DeviceList.length > 0) {
                var _curObj = this.rhythmModel.DeviceList[0];
                console.log('this.wifiData', this.wifiData, _curObj);

                this.radio1 = this.wifiData.find(item => { return item.VDeviceId == _curObj.VDeviceId }) || {};
              }
            } else if (this.rhythmModel.DeviceList.length > 0) {
                var _curObj = this.rhythmModel.DeviceList[0]
                console.log('this.wifiData 2', this.wifiData, _curObj);
                this.radio1 = this.wifiData.find(item => { return item.VDeviceId == _curObj.ParentVDeviceId }) || {};
              }

            // 修改网关赋值
            // this.updaterefresh(2);
            // if(this.rhythmModel!=null){
            //   this.active_step=3;
            // }
            // setTimeout(param => {
            //   this.$refs.deviceSelect.refresh();
            // }, 100);
          } else {
            this.radio1 = this.wifiData[0]
            this.changegateway()
          }
        } else {

        }
      }
    },
    /* 查询网关
		* _vid 设备id
		*/
    // doGetWayGate(_vid) {
    // 	var para = { vDeviceId: _vid };
    // 	FindDevice(para, this.functionDoFindDevice);
    // 	para = null;
    // },
    /* 查询网关 接口返回数据处理 去查询该网关下所有的设备 并选中
		* rs 接口返回数据包
		* para 接口参数
		*/
    // functionDoFindDevice(rs, para) {
    // 	if (rs.StatusCode == this.$store.state.rightStatusCode) {
    // 		if (this.wifiData.length > 0) {
    // 			this.wifiData.forEach(n => {
    // 				if (n.VDeviceId == rs.Result.ParentVDeviceId) {
    // 					this.radio1 = n;
    // 					this.getCheckDevice();
    // 				}
    // 			});
    // 		}
    // 	}
    // },
    getPostFunParam () {
      const param = {
        _gpNo: this.areaid,
        pageIndex: 1,
        pageSize: this.$store.state.pageTotalLimit,
        childCategoryType: '2,16',
        gatewayVDeviceId: this.radio1.VDeviceId
      }
      if (this.rhythmModel != null && this.rhythmModel.RhythmNo != null) {
        param.rhythmNo = this.rhythmModel.RhythmNo
      }
      return param
    },
    /* 去查询该网关下所有的设备 并选中
		*/
    // getCheckDevice() {
    // 	this.updaterefresh(1);
    // 	var para = {
    // 		gpNo: this.areaid,
    // 		pageIndex: 1,
    // 		pageSize: 2000,
    // 		deviceType: 2,
    // 		gatewayVDeviceId: this.radio1.VDeviceId
    // 	};
    // 	FindDeviceListByPage(para, this.functionDoFindDeviceListByPageToCheck);
    // 	para = null;
    // },
    /* 去查询该网关下所有的设备 并选中 接口返回数据处理
		* rs 接口返回数据包
		*/
    // functionDoFindDeviceListByPageToCheck(rs) {
    // 	this.card_list = [];
    // 	if (rs.StatusCode == this.$store.state.rightStatusCode) {
    // 		if(rs.Result != null && rs.Result.RecordList != null) {
    // 			rs.Result.RecordList.forEach(item => {
    // 				item.flag = false; //是否可编辑
    // 				item.ischecked = false; //是否默认选中
    // 				item.isflicker = false; //是否闪烁
    // 				item.isdisabled = false; //是否禁用

    // 				if (item.StatusInfo) {
    // 					if (item.StatusInfo != null && item.StatusInfo != '') {
    // 						item.StatusInfo = JSON.parse(item.StatusInfo);
    // 					} else {
    // 						item.StatusInfo = [];
    // 					}
    // 				}

    // 				this.rhythmModel.DeviceList.forEach(m => {
    // 					if (item.VDeviceId == m.VDeviceId && item.ChildId == m.ChannelId) {
    // 						item.ischecked = true; //是否默认选中
    // 						console.log(item);

    // 						this.checkDevice.push(item);
    // 					}
    // 				});
    // 				this.card_list.push(item);
    // 			});
    // 		}
    // 	}
    // 	this.updaterefresh(2);
    // },
    /* 需不要显示加载中
		*/
    updaterefresh (_type) {
      if (_type == 1) {
        this.refresh = false
        this.loading = true
      } else {
        this.refresh = true
        this.loading = false
      }
    },
    /* 点击切换网关
		*/
    changegateway () {
      // 获得网关
      this.checkDevice = []
      // this.initsocket();
      // this.doFindDeviceListByPage();
    },
    /* 根据网关获得网关下的设备
		*/
    // doFindDeviceListByPage() {
    // 	//获得对应设备
    // 	if(this.radio1){
    // 		this.updaterefresh(1);
    // 		var para = {
    // 			gpNo: this.areaid,
    // 			pageIndex: 1,
    // 			pageSize: 2000,
    // 			deviceType: 2,
    // 			gatewayVDeviceId: this.radio1.VDeviceId
    // 		};
    // 		FindDeviceListByPage(para, this.functionDoFindDeviceListByPage);
    // 		para = null;
    // 	}

    // },
    /* 根据网关获得网关下的设备 接口返回数据处理
		* rs 接口返回数据包
		*/
    // functionDoFindDeviceListByPage(rs) {
    //
    // 	console.log(rs);
    // 	this.card_list = [];
    // 	if (rs.StatusCode == this.$store.state.rightStatusCode) {
    // 		if(rs.Result != null && rs.Result.RecordList != null) {
    //       this.sortResult("device", rs.Result,"RecordList");
    // 			rs.Result.RecordList.forEach(item => {
    // 				item.flag = false; //是否可编辑
    // 				item.ischecked = false; //是否默认选中
    // 				item.isflicker = false; //是否闪烁
    // 				item.isdisabled = false; //是否禁用

    // 				if (item.StatusInfo) {
    // 					if (item.StatusInfo != null && item.StatusInfo != '') {
    // 						item.StatusInfo = JSON.parse(item.StatusInfo);
    // 					} else {
    // 						item.StatusInfo = [];
    // 					}
    // 				}
    // 				this.card_list.push(item);
    // 			});
    // 		} else {
    // 			this.card_list = [];
    // 			this.checkDevice = [];
    // 		}
    // 	} else {
    // 		this.card_list = [];
    // 		this.checkDevice = [];
    // 	}
    // 	if (this.checkDevice.length > 0) {
    // 		this.card_list.forEach(n => {
    // 			this.checkDevice.forEach(m => {
    // 				if (n.VDeviceId == m.VDeviceId && n.ChildId == m.ChildId) {
    // 					n.ischecked = true;
    // 				}
    // 			});
    // 		});
    // 	}
    // 	this.updaterefresh(2);
    // 	//this.LightStep = 2;
    // 	//this.cardlist=this.card_list;
    // },
    /* 选择 好设备 点击确定
		*/
    createGrop () {
      if (this.doVerification(false)) {
        if (this.active_step < 3) {
          this.active_step = this.active_step + 1
        } else {
          this.active_step = 3
        }
      }
    },
    /* 点击下一步
		*/
    upstep2 () {
      if (this.active_step > 1) {
        this.active_step = this.active_step - 1
      } else {
        this.active_step = 1
      }
    },
    /* 验证要提交的数据 是否符合
		*/
    doVerification (ispost) {
      if (this.checkDevice.length == 0 && this.isGroupPost == false) {
        warning(this, this.$t('ifttt.warning1'))
        return false
      } else if (ispost) {
          if (this.lightTimeList.length > 0) {
            return true
          } else {
            warning(this, this.$t('ifttt.warning2'))
            return false
          }
        } else {
          return true
        }
    },
    docheckTimeisEndToStar (item, tag1, tag2, notrip) {
      let param = item[tag1]
      let _s = param[0]; let _sh; let _sm
      if (typeof _s === 'string' && _s != null) {
        _s = _s.split(':')
        _sh = _s[0]
        _sh = parseInt(_sh)
        _sm = _s[1]
        _sm = parseInt(_sm)
      } else {
        item[tag1][0] = '00:00'
        _sh = 0
        _sm = 0
      }

      let _e = param[1]; let _eh; let _em
      if (typeof _e === 'string' && _e != null) {
        _e = _e.split(':')
        _eh = _e[0]
        _eh = parseInt(_eh)
        _em = _e[1]
        _em = parseInt(_em)
      } else {
        item[tag1][1] = '00:00'
        _eh = 0
        _em = 0
      }

      if (_sh == null || _sm == null || _eh == null || _em == null ||
        _sh > _eh || _sh == _eh && _sm > _em) {
        item[tag2] = true
        if (notrip == null) { warning(this, this.$t('ifttt.timeStarToEnd')) }
        param = null
        _sh = null
        _sm = null
        _eh = null
        _em = null
        return true
      } else {
        item[tag2] = false

        param = null
        _s = null
        _sh = null
        _sm = null
        _e = null
        _eh = null
        _em = null
        return false
      }
    },
    /* 检查选择的时间段是否有冲突
		*/
    docheckTimeisRight () {
      let ispost = true
      if (this.lightTimeList.length > 0) {
        this.lightTime = []
        this.windowtime = []
        this.lightTimeList.forEach(n => {
          // if(n["error"]==true){ispost=false;}
          if (n.DevType == 1) {
            this.lightTime.push(n)
          } else if (n.DevType == 2) {
            this.windowtime.push(n)
          }
        })

        // var _st,_ed,_t1,_t2;
        // if(this.lightTime.length>0){
        // 	for (let i = 0; i < this.lightTime.length; i++) {
        // 		_st= parseInt(this.lightTime[i].time[0]);
        // 		_ed=parseInt(this.lightTime[i].time[1]);
        // 		for (let t = 0; t < this.lightTime.length; t++) {
        // 			if(i!=t){
        // 				_t1=parseInt(this.lightTime[t].time[0]);
        // 				_t2=parseInt(this.lightTime[t].time[1]);
        // 				if((_st>=_t1&&_st<_t2)||_ed>_t1&&_ed<=_t2){
        // 					ispost=false;
        // 				}
        // 			}
        // 		}
        // 	}
        // }

        let t3; let i = 0
        if (this.lightTime.length > 0) {
          for (; i < this.lightTime.length; i++) {
            if (t3 != null) {
              if (this.docheckTimeisEndToStar({ time: [t3.time[1], this.lightTime[i].time[0]] }, 'time', 'error', false)) {
                ispost = false
                this.lightTime[i].error = true
                continue
              }
            }
            if (this.docheckTimeisEndToStar(this.lightTime[i], 'time', 'error', false)) {
              ispost = false
            }
            t3 = this.lightTime[i]
          }
        }

        // if(this.windowtime.length>0){
        // 	for (; i < this.windowtime.length; i++) {
        // 		_st= parseInt(this.windowtime[i].time[0]);
        // 		_ed=parseInt(this.windowtime[i].time[1]);
        // 		for (let t = 0; t < this.windowtime.length; t++) {
        // 			if(i!=t){
        // 				_t1=parseInt(this.windowtime[t].time[0]);
        // 				_t2=parseInt(this.windowtime[t].time[1]);
        // 				if((_st>=_t1&&_st<_t2)||_ed>_t1&&_ed<=_t2){
        // 					ispost=false;
        // 				}
        // 			}
        // 		}
        // 	}
        // }

        if (this.windowtime.length > 0) {
          i = 0
          t3 = null
          for (; i < this.windowtime.length; i++) {
            if (t3 != null) {
              if (this.docheckTimeisEndToStar({ time: [t3.time[1], this.windowtime[i].time[0]] }, 'time', 'error', false)) {
                ispost = false
                this.windowtime[i].error = true
                continue
              }
            }
            if (this.docheckTimeisEndToStar(this.windowtime[i], 'time', 'error', false)) {
              ispost = false
            }
            t3 = this.windowtime[i]
          }
        }
        i = null
        t3 = null

        this.lightTimeList.forEach(n => {
          if (n.error == true) { ispost = false }
        })

        // _st = null;
        // _ed = null;
        // _t1 = null;
        // _t2 = null;
        return ispost
      }
    },
    /* 去保存数据
		*/
    doSave () {
      if (this.doVerification(true)) {
        if (!this.docheckTimeisRight()) {
          warning(this, this.$t('ifttt.warning3'))
          return
        }
        this.btnloading = true
        const postData = {}
        postData.GpNo = this.areaid
        postData.Mode = this.modetype
        postData.DeviceList = []
        postData.ActionList = []
        postData.RhythmType = this.isGroupPost ? 0 : 1
        postData.RhythmName = this.name

        if (this.isGroupPost == true) {
          if (this.radio1 != null) {
            postData.DeviceList = []
            postData.DeviceList.push({
              VDeviceId: this.radio1.VDeviceId,
              DeviceName: this.radio1.DeviceName,
              ChannelId: this.radio1.ChildId != null ? this.radio1.ChildId : this.radio1.ChannelId
            })
          }
        } else {
          this.checkDevice.forEach(n => {
            postData.DeviceList.push({
              VDeviceId: n.VDeviceId,
              DeviceName: n.DeviceName,
              ChannelId: n.ChildId != null ? n.ChildId : n.ChannelId,
              // ParentVDeviceId: n.ParentVDeviceId
              ParentVDeviceId: this.radio1.VDeviceId
            })
          })
        }
        if (this.lightTimeList.length > 0) {
          this.lightTimeList.forEach(n => {
            const tempmodel = {}
            // console.log(n);
            const _st = n.time[0].split(':')
            const _ed = n.time[1].split(':')
            tempmodel.StartHour = Number(_st[0])
            tempmodel.StartMin = Number(_st[1])
            tempmodel.EndHour = Number(_ed[0])
            tempmodel.EndMin = Number(_ed[1])
            tempmodel.DevType = n.DevType // 灯设备
            tempmodel.Bright = this.rhythmlLightInforValueSubmit(n.Bright)
            tempmodel.Opendegree = n.Opendegree
            tempmodel.Degree = n.Opendegree === 0 ? n.Degree : 0
            tempmodel.CtrlType = n.CtrlType
            tempmodel.CCT = n.CCT
            tempmodel.Illuminance = n.Illuminance
            tempmodel.EnableLight = n.EnableLight
            tempmodel.EnableCCT = n.EnableCCT
            tempmodel.EnableRGB = n.EnableRGB
            if (n.CtrlType == 0) {
              const _int = '0x' + n.RGB.substr(1)
              tempmodel.RGB = parseInt(_int)
            } else {
              tempmodel.RGB = n.RGB
            }

            postData.ActionList.push(tempmodel)
            // tempmodel.
          })
        }

        if (this.rhythmModel != null && this.rhythmModel.RhythmNo != null) {
          // 修改
          postData.RhythmName = this.name// this.rhythmModel.RhythmName;
          postData.RhythmNo = this.rhythmModel.RhythmNo
          Edit(postData, this.functionDoNotice)
        } else {
          // 新增
          Create(postData, this.functionDoNotice)
        }
      }
    },
    saverhythmModel () {
      if (this.doVerification(true)) {
        if (!this.docheckTimeisRight()) {
          warning(this, this.$t('ifttt.warning4'))
          return
        }
        var postData = {}
        postData.GpNo = this.areaid
        postData.Mode = this.modetype
        postData.DeviceList = []
        postData.ActionList = []
        postData.RhythmType = this.isGroupPost ? 0 : 1

        this.checkDevice.forEach(n => {
          postData.DeviceList.push({
            VDeviceId: n.VDeviceId,
            DeviceName: n.DeviceName,
            ChannelId: n.ChildId != null ? n.ChildId : n.ChannelId
          })
        })

        if (this.lightTimeList.length > 0) {
          this.lightTimeList.forEach(n => {
            const tempmodel = {}
            // console.log(n);
            const _st = n.time[0].split(':')
            const _ed = n.time[1].split(':')
            tempmodel.StartHour = Number(_st[0])
            tempmodel.StartMin = Number(_st[1])
            tempmodel.EndHour = Number(_ed[0])
            tempmodel.EndMin = Number(_ed[1])
            tempmodel.DevType = n.DevType // 灯设备
            tempmodel.Bright = this.rhythmlLightInforValueSubmit(n.Bright)
            tempmodel.Opendegree = n.Opendegree
            tempmodel.Degree = tempmodel.Opendegree === 0 ? n.Degree : 0
            tempmodel.CtrlType = n.CtrlType
            tempmodel.CCT = n.CCT
            tempmodel.Illuminance = n.Illuminance
            tempmodel.EnableLight = n.EnableLight
            tempmodel.EnableCCT = n.EnableCCT
            tempmodel.EnableRGB = n.EnableRGB
            if (n.CtrlType == 0) {
              const _int = '0x' + n.RGB.substr(1)
              tempmodel.RGB = parseInt(_int)
            } else {
              tempmodel.RGB = n.RGB
            }
            postData.ActionList.push(tempmodel)
          })
        }
        if (this.rhythmModel != null && this.rhythmModel.RhythmNo != null) {
          // 修改
          postData.RhythmName = this.rhythmModel.RhythmName
          postData.RhythmNo = this.rhythmModel.RhythmNo
        } else {
          // 新增
          postData.RhythmName = this.areaid + '.' + this.$t('ifttt.rhythm')
        }
      }
      this.rhythmModel = postData
    },
    /* 去保存数据 接口返回数据处理
		* rs 接口返回数据包
		*/
    functionDoNotice (rs, para) {
      this.btnloading = false
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        this.$emit('RhythmOK', para.GpNo)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 按钮点击保存执行
		*/
    save () {
      this.doSave()
    },
    /* 全选
	*/
    checkAll (e) {
	      if (e) {
	      		this.select = true
	      } else {
	      		this.select = false
	      }
		   this.selectCheckBox(e)
	  },
	  /* 执行全选操作
	  */
    selectCheckBox (_flag) {
      let _arr = []
      this.card_list.forEach(item => {
        if (!item.isdisabled) {
          item.ischecked = _flag // 全选
        }
        _arr.push(item)
      })
      this.cardlist = _arr
      this.getCheckedDataDevice()
      _arr = null
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapperMyself {
  .save_blue {
    margin-left: 60px;
    background: #2a72ea !important;
    border: solid 1px #2a72ea !important;
  }
  .save_blue:hover,
  .save_blue:focus,
  .save_blue:active {
    background: #2a72ea !important;
    border: solid 1px #2a72ea !important;
  }
}
.ehy_cont {
  overflow: hidden;
}
</style>
